import { Block, useStyletron } from "@mezo-org/mezo-clay"

import { selectIsConnected, useDappSelector } from "#/redux-state"
import { ENABLE_SWAPS } from "#/shared/constants"
import { BridgeAssetButton, SwapButton } from "#/ui/Button"

import DashboardHeaderExplorer from "./DashboardHeaderExplorer"

export default function DashboardHeaderActions() {
  const isConnected = useDappSelector(selectIsConnected)
  const [css, theme] = useStyletron()

  return (
    <Block className={css({ display: "flex", gap: theme.sizing.scale500 })}>
      {isConnected && (
        <>
          <BridgeAssetButton kind="secondary" />
          {ENABLE_SWAPS && <SwapButton />}
        </>
      )}
      <DashboardHeaderExplorer />
    </Block>
  )
}
